import { createContext } from 'react'

export enum ScreenWidthCategory {
  ExtraExtraSmall,
  ExtraSmall,
  Small,
  Medium,
  Large,
  ExtraLarge
}

export const screenWidthCategoryFromWidth = (screenWidth: number) => {
  if (screenWidth <= 480) {
    return ScreenWidthCategory.ExtraExtraSmall
  } else if (screenWidth <= 620) {
    return ScreenWidthCategory.ExtraSmall
  } else if (screenWidth <= 768) {
    return ScreenWidthCategory.Small
  } else if (screenWidth <= 1024) {
    return ScreenWidthCategory.Medium
  } else if (screenWidth <= 1440) {
    return ScreenWidthCategory.Large
  }
  return ScreenWidthCategory.ExtraLarge
}

export const ScreenWidthCategoryContext = createContext<ScreenWidthCategory>(ScreenWidthCategory.Medium)
